interface CurrencyOption {
    currencyId: number;
    element: HTMLElement;
}

export default class CurrencySelector {
    baseElement: Element;
    currencyOptions: CurrencyOption[];
    cookieName: string = 'currencyId';

    init(baseElement: Element): void {
        this.baseElement = baseElement;
        this.currencyOptions = this.createCurrencyOptions(this.baseElement.querySelectorAll('p[data-value]'));
        this.registerOptionListeners();
    }

    private registerOptionListeners(): void {
        this.currencyOptions.forEach((option: CurrencyOption) => {
            option.element.addEventListener('click', (e: Event) => {
                e.preventDefault();
                this.setCurrencyCookieAndReload(option.currencyId);
            })
        });
    }

    private createCurrencyOptions(elements: NodeList): CurrencyOption[] {
        let currencyOptions: CurrencyOption[] = [];
        elements.forEach(item => {
            currencyOptions.push(
                {
                    element: <HTMLElement>item,
                    currencyId: Number((item as HTMLElement).getAttribute('data-value'))
                });
        })

        return currencyOptions;
    }

    private setCurrencyCookieAndReload(currencyId: number): void {
        let cookieExpire = new Date();
        cookieExpire.setMonth(cookieExpire.getMonth() + 12);

        document.cookie = `${this.cookieName}=${currencyId}; expires=${cookieExpire}; path=/`;

        window.location.reload();
    }
}

